/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import * as XLSX from 'xlsx';
import exportFromJSON from 'export-from-json';
import { Grid, Menu, MenuItem, Typography, Box, Tab } from '@mui/material';
import { TabList, TabContext, TabPanel } from '@mui/lab';
import { copyCell, copyCellHead, copyColHead, copyRowHead, copyTable } from '../uigrid/helper';

import UIGrid from '../uigrid';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'; // Optional theme CSS
import BasicInput from '../uigrid/basic-input';

// sorting explorer tab based on below value GB-2927 added by chandrashekhar
// const explorerTabValue = ['DSSRO mode', 'PV', 'Recovery', 'Flow', 'Total Circuits', 'Duration', 'Volume'];
const explorerTabValue = ['DSSRO mode', 'PV', 'Recovery', 'Flow', 'Total', 'Duration', 'Volume'];
// sorting explorer tab based on upper value GB-2927 added by chandrashekhar

const disableInput = true;
const CLROPage = (props) => {
  const { stagesList, unit_set_dict, clroOverView, report_invoice, stageData, isInitialRender, setIsInitialRender } = props;
  const [roRowData1, setRoRowData1] = useState([]);
  const roData = stagesList[0];
  const clroTable1 = report_invoice;
  const SatJsonData = roData.sat_indices || roData.product.sat_indices;
  const [activeTab, setActiveTab] = useState('1');
  // Added by Abhishek on 4-March-24 : for csv/excel export issue
  const [contextMenu, setContextMenu] = React.useState(null);
  const [fileName] = useState('clroTable2' || 'export');
  const [griddata, setGridData] = useState('' || []);
  const [properties, setproperties] = useState([]);
  const [targetValue, setTargetValue] = useState('');
  const [targetElement, setTargetElement] = useState('');
  // const [isInitialRender, setIsInitialRender] = useState(true);

  // clro overview
  const [griddata_co, setGridData_co] = useState('' || []);
  const [properties_co, setproperties_co] = useState([]);

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
        }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
        // Other native context menus might behave different.
        // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
        null,
    );
  };

  const handleContextMenu_co = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
        }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
        // Other native context menus might behave different.
        // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
        null,
    );
  };

  function changeFocus(e) {
    if (e.target)
      e.target.select();
    if (props.onfocus)
      props.onfocus(e);
  }

  const handleClose = () => {
    setContextMenu(null);
  };

  const handleRightClick = (e) => {
    setTargetElement(e.target.id);
    setTargetValue(e.target.value);
    $('.react-contextmenu').css({ display: 'block' });
  };

  const [roColData1] = useState([
    { tag: 'circuit', hdata: '<span>Circuit</span>', maxWidth: 50, minWidth: 20, disabled: true },
    { tag: 'element', hdata: '<span>Element</span>', minWidth: 20, disabled: true },
    { tag: 'recovery', hdata: '<span>Recovery <br />(%)</span>', disabled: true },
    { tag: 'feed_flow', hdata: `<span>Feed flow  <br /> (${unit_set_dict['Volume Flow']})</span>`, disabled: true },
    { tag: 'feed_press', hdata: `<span>Feed Press  <br /> (${unit_set_dict.Pressure})</span>`, disabled: true },
    { tag: 'feed_tds', hdata: '<span>Feed TDS  <br /> (mg/L)</span>', disabled: true },
    { tag: 'conc_flow', hdata: `<span>Conc Flow  <br /> (${unit_set_dict['Volume Flow']})</span>`, disabled: true },
    { tag: 'perm_flow', hdata: `<span>Prem Flow  <br /> (${unit_set_dict['Volume Flow']})</span>`, disabled: true },
    { tag: 'perm_tds', hdata: '<span>Perm TDS  <br /> (mg/L)</span>', disabled: true }
  ]);

  function getValue(item, num) {
    if (item !== '' && item !== 0 && !Number.isNaN(Number(item))) {
      if (num) {
        return Number(item).toFixed(num);
      }
      return Number(item);
    }
    return item;
  }

  function getFlowValue(item, num = 2) {
    if (unit_set_dict['Volume Flow'] === 'm3/s') {
      if (item >= 0.01) {
        return Number.parseFloat(item).toFixed(num);
      }
      return Number.parseFloat(item).toExponential(num);
    }
    return Number.parseFloat(item).toFixed(num);
  }

  useEffect(() => {
    if (isInitialRender) {
      const roarr_rowdata1 = [];
      if (Object.keys(clroTable1).length > 1 && Object.keys(clroTable1.units).length > 0) {
        clroTable1['CLRO Unit ID'].map((key) => {
          if (key === stageData.name) {
            const clroContent = clroTable1[key];
            Object.keys(clroContent.Elements).forEach((data) => {
              Object.keys(clroContent.Elements[data]).forEach((ele) => {
                const obj = clroContent.Elements[data][ele];
                roarr_rowdata1.push({
                  circuit: data,
                  element: ele,
                  recovery: getFlowValue(obj.Recovery, 2),
                  feed_flow: getFlowValue(obj['Feed Flow'], 2),
                  feed_press: getFlowValue(obj['Feed Press'], 2),
                  feed_tds: getFlowValue(obj['Feed TDS'], 2),
                  conc_flow: getFlowValue(obj['Conc Flow'], 2),
                  perm_flow: getFlowValue(obj['Perm Flow'], 2),
                  perm_tds: getFlowValue(obj['Perm TDS'], 2)
                });
              });
            });
          }
        });
      }
      setRoRowData1(roarr_rowdata1);
      setIsInitialRender(false);

      // by Abhishek

      const propertie = [{ 'tag': 'Concentrations', 'hdata': 'Concentrations', 'disabled': true }];
      const obj = {};
      clroTable1['CLRO Unit ID'].forEach((ele) => {
        if (ele === stageData.name) {
          const clroContent = clroTable1[ele];
          Object.keys(clroContent.Concentrations).forEach((data) => {
            Object.keys(clroContent.Concentrations[data]).forEach((data1) => {
              propertie.push({ 'tag': `${data}-${data1}`, 'hdata': `${data1}`, 'disabled': true });
              Object.keys(clroContent.Concentrations[data][data1]).forEach((eee) => {
                if (obj[eee]) {
                  obj[eee].push({ Concentrations: eee, key: `${data}-${data1}`, [`${data}-${data1}`]: clroContent.Concentrations[data][data1][eee] });
                } else {
                  obj[eee] = [{ Concentrations: eee, key: `${data}-${data1}`, [`${data}-${data1}`]: clroContent.Concentrations[data][data1][eee] }];
                }
              });
            });
          });
        }
      });
      const finalData = [];
      Object.keys(obj).forEach((ele) => {
        const abc = {};
        obj[ele].forEach((ele1) => {
          abc.Concentrations = ele1.Concentrations;
          abc[ele1.key] = ele1[ele1.key];
        });
        finalData.push(abc);
      });
      setproperties(propertie);
      setGridData(finalData);
    }
  }, [roRowData1, isInitialRender]);

  useEffect(() => {

    if (clroOverView) {
      const propertie = [
        { 'tag': 'Parameters', 'hdata': 'Parameters', 'maxWidth': 50, 'minWidth': 20, 'disabled': true },
        { 'tag': 'Units', 'hdata': 'Units', 'maxWidth': 50, 'minWidth': 20, 'disabled': true },
        { 'tag': 'Values', 'hdata': 'Values', 'maxWidth': 50, 'minWidth': 20, 'disabled': true },
      ];
      setproperties_co(propertie);
      const data = [];
      Object.keys(clroOverView).map((clroObj) => {
        if (clroObj === stageData.name) {
          // Object.keys(clroOverView[clroObj]).map((clroview) => {
          explorerTabValue.map((clroview) => {
            if (clroview !== 'units') {
              const units = clroOverView[clroObj].units[clroview];
              if (Object.prototype.toString.call(clroOverView[clroObj][clroview]) === '[object Object]') {
                return Object.keys(clroOverView[clroObj][clroview]).map((ele) => {
                  const val = clroOverView[clroObj][clroview][ele];
                  const obj = { 'Parameters': ele, 'Units': units, 'Values': val };
                  data.push(obj);
                });
              }
              const ele = clroview;
              const val = clroOverView[clroObj][clroview];
              const obj = { 'Parameters': ele, 'Units': units, 'Values': val };
              data.push(obj);
            }
          });
        }
      });
      setGridData_co(data);
    }
  }, [clroOverView]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const clroOverViewContent = (ele, units, value, ind, index) => {
    let values = value;
    if (Object.prototype.toString.call(values) === '[object Number]' && values.toString().indexOf('.') >= 0) {
      values = getValue(value, 2);
    }
    return (
      <tr key={ind} className={`${index % 2 === 0 ? 'row-odd' : 'row-even'}`}>
        <td className={`cell cell_${index}_${ind + 1}`}>
          <Typography id='custom_menu'>
            <BasicInput
              value={ele}
              disabled={disableInput}
              id={`input_num${index}_${ind + 1}`}
              onFocus={(e) => { changeFocus(e); }}
              onContextMenu={handleRightClick}
            />
          </Typography>
        </td>
        <td className={`cell cell_${index}_${ind + 1}`}>
          <Typography id='custom_menu'>
            <BasicInput
              value={units}
              disabled={disableInput}
              id={`input_num${index}_${ind + 1}`}
              onFocus={(e) => { changeFocus(e); }}
              onContextMenu={handleRightClick}
            />
          </Typography>
        </td>
        <td className={`cell cell_${index}_${ind + 1}`}>
          <Typography id='custom_menu'>
            <BasicInput
              value={values}
              disabled={disableInput}
              id={`input_num${index}_${ind + 1}`}
              onFocus={(e) => { changeFocus(e); }}
              onContextMenu={handleRightClick}
            />
          </Typography>
        </td>
      </tr>
    );
  };
  return (
    <div className='App'>
      <Grid container style={{ padding: '0px 12px' }}>
        {Object.keys(report_invoice.units).length > 0 ? (<TabContext value={activeTab} >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='tab-context'>
            <TabList aria-label='lab API tabs example' onChange={handleChange} className='tab-content'>
              <Tab label='DSSRO Overview' value='1' />
              <Tab label='Table 1' value='2' />
              <Tab label='Table 2' value='3' />
            </TabList>
          </Box>
          <TabPanel value='1' className='splitter-mixer-container' style={{ padding: (activeTab === '1') ? '30px 0 20px 0' : '0', display: 'flex', width: '100%' }}>
            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
              <div className='ag-theme-alpine ag-custom explorer-ag-grid clro_latest_table' style={{ fontSize: '12px' }}>
                <div>
                  {(() => {
                    if (clroOverView) {
                      return Object.keys(clroOverView).map((clroObj) => {
                        if (clroObj === stageData.name) {
                          return (
                            <div className='UIGrid' onContextMenu={handleContextMenu_co} style={{ cursor: 'context-menu' }}>
                              <table id='grid'>
                                <thead>
                                  <tr className='header_row'>
                                    <th className='hcell' aria-label='space'>Parameters</th>
                                    <th className='hcell' aria-label='space'>Units</th>
                                    <th className='hcell' aria-label='space'>Values</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* {Object.keys(clroOverView[clroObj]).map((clroview, index) => { */}
                                  {explorerTabValue.map((clroview, index) => {
                                    if (clroview !== 'units') {
                                      const units = clroOverView[clroObj].units[clroview];
                                      if (Object.prototype.toString.call(clroOverView[clroObj][clroview]) === '[object Object]') {
                                        return Object.keys(clroOverView[clroObj][clroview]).map((ele, ind) => {
                                          const val = clroOverView[clroObj][clroview][ele];
                                          return clroOverViewContent(ele, units, val, ind, index);
                                        });
                                      }
                                      const ele = clroview;
                                      const val = clroOverView[clroObj][clroview];
                                      return clroOverViewContent(ele, units, val, index, index);
                                    }
                                  })}
                                </tbody>
                              </table>
                              {/* By ABhishek  */}
                              <Menu id='custom_menu'
                                open={contextMenu !== null}
                                onClose={handleClose}
                                anchorReference='anchorPosition'
                                anchorPosition={
                                  contextMenu !== null
                                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                    : undefined
                                }
                              >
                                <MenuItem onClick={() => { copyCell(targetValue); handleClose(); }}>
                                  <span>Copy</span>
                                </MenuItem>
                                <MenuItem onClick={() => { copyCellHead(targetElement, properties_co, targetValue); handleClose(); }}>
                                  <span>Copy Cell with Headers</span>
                                </MenuItem>
                                <MenuItem onClick={() => { copyRowHead(targetElement, properties_co, griddata_co); handleClose(); }}>
                                  <span>Copy Row with Headers</span>
                                </MenuItem>
                                <MenuItem onClick={() => { copyColHead(targetElement, properties_co, griddata_co); handleClose(); }}>
                                  <span>Copy Column with Headers</span>
                                </MenuItem>
                                <MenuItem onClick={() => { copyTable(properties_co, griddata_co); handleClose(); }}>
                                  <span>Copy Table </span>
                                </MenuItem>
                                <MenuItem onClick={() => { exportFromJSON({ data: griddata_co, fileName: 'clroOverview', exportType: 'csv' }); handleClose(); }}>
                                  <span>Export as CSV</span>
                                </MenuItem>
                                <MenuItem onClick={() => {
                                  const worksheet = XLSX.utils.json_to_sheet(griddata_co);
                                  const workbook = XLSX.utils.book_new();
                                  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                                  XLSX.writeFile(workbook, 'clroOverview.xlsx');
                                  handleClose();
                                }}>
                                  <span>Export as Excel</span>
                                </MenuItem>
                              </Menu>
                            </div>
                          );
                        }
                      });
                    }
                  })()}
                </div>
              </div>
            </Grid>
          </TabPanel>
          <TabPanel value='2' className='splitter-mixer-container' style={{ padding: (activeTab === '2') ? '30px 0 20px 0' : '0', display: 'flex' }}>
            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
              <div className='ag-theme-alpine ag-custom explorer-ag-grid clro_latest_table' style={{ fontSize: '12px' }}>
                <div>
                  <UIGrid
                    data={roRowData1}
                    properties={roColData1}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <div className='ag-theme-alpine ag-custom stream-modal' style={{ marginTop: '2%' }}>
                <div style={{ fontSize: '12px', color: '#2C2C2C' }} className='box-border rufusReg M_Bold no_drag'>Saturation Data(Concentrate)</div>
                <div className='form-grid sansW4SeLig expSatDataCon'>
                  {(() => {
                    const data = [
                      { 'BaSO4': SatJsonData.baso4 },
                      { 'CaF2': SatJsonData.caf2 },
                      { 'CaSO4': SatJsonData.caso4 },
                      { 'SiO2': SatJsonData.sio2 },
                      { 'SrSO4': SatJsonData.srso4 },
                      { 'Struvite': SatJsonData.struvite },
                      { 'LSI': SatJsonData.lsi },
                      { 'S&DSI': SatJsonData.sdi },
                      { 'Osm.Press': getValue(SatJsonData.osmotic_pressure, 2) },
                      { 'Conductivity': `${SatJsonData.conductivity} µS/cm` },
                    ];
                    return data.map((ele, ind) => {
                      const key = Object.keys(ele);
                      return (
                        <div className='box-column w-50 label-text' key={ind}>
                          <div className='f-left sub-left no_drag'>{key[0]}</div>
                          <div className='f-right sub-right no_drag'>{ele[key[0]]}</div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>
            </Grid>
          </TabPanel>
          <TabPanel value='3' className='splitter-mixer-container' style={{ padding: (activeTab === '3') ? '30px 0 20px 0' : '0', display: 'flex', width: '100%' }}>
            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
              <div className='ag-theme-alpine ag-custom explorer-ag-grid clro_latest_table' style={{ fontSize: '12px' }}>
                <div>
                  {(() => {
                    let catkey = [];
                    return (
                      <div className='UIGrid' onContextMenu={handleContextMenu} style={{ cursor: 'context-menu' }}>
                        <table id='grid'>
                          <thead>
                            <tr className='header_row'>
                              <th className='hcell' colSpan='11'><span>Concentrations (mg/L as ion)</span></th>
                            </tr>
                            <tr className='header_row'>
                              <th className='hcell' aria-label='space' rowSpan='2'>&nbsp;&nbsp;</th>
                              {clroTable1['CLRO Unit ID'].map((key) => {
                                if (key === stageData.name) {
                                  const clroContent = clroTable1[key];
                                  return Object.keys(clroContent.Concentrations).map((data, index) => {
                                    if (data.toLocaleLowerCase() === 'feed') {
                                      return (<th key={index} className='hcell' rowSpan='2'><span>{data}</span></th>);
                                    }
                                    return (<th key={index} className='hcell' colSpan='3'><span>{data}</span></th>);
                                  });
                                }
                                return '';
                              })}
                            </tr>
                            <tr className='header_row'>
                              {clroTable1['CLRO Unit ID'].map((key) => {
                                if (key === stageData.name) {
                                  const clroContent = clroTable1[key];
                                  return Object.keys(clroContent.Concentrations).map((data) => {
                                    if (data.toLocaleLowerCase() !== 'feed') {
                                      return Object.keys(clroContent.Concentrations[data]).map((subData, sunInd) => {
                                        return (<th key={sunInd} className='hcell' ><span>{subData}</span></th>);
                                      });
                                    }
                                    catkey = Object.keys(clroContent.Concentrations[data][data]);
                                  });
                                }
                                return '';
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {clroTable1['CLRO Unit ID'].map((key) => {
                              if (key === stageData.name) {
                                const clroContent = clroTable1[key];
                                return catkey.map((eleData, eleDataInd) => {
                                  return (
                                    <tr key={eleDataInd} className={`row_${eleDataInd + 1} ${eleDataInd % 2 === 0 ? 'row-odd' : 'row-even'}`}>
                                      {Object.keys(clroContent.Concentrations).map((element, elementInd) => {
                                        return Object.keys(clroContent.Concentrations[element]).map((ele, ind) => {
                                          return (
                                            <React.Fragment key={ind}>
                                              {element === 'Feed' && (
                                                <td id={`cell${ind + 1}`} className={`cell cell_${elementInd}_${ind + 1}`}>
                                                  <Typography id='custom_menu'>
                                                    <BasicInput
                                                      value={getValue(eleData, 2)}
                                                      disabled={disableInput}
                                                      id={`input_num${elementInd}_${ind + 1}`}
                                                      onFocus={(e) => { changeFocus(e); }}
                                                      onContextMenu={handleRightClick}
                                                    />
                                                  </Typography>
                                                </td>
                                              )}
                                              <td id={`cell${ind + 1}`} className={`cell cell_${elementInd}_${ind + 1}`}>
                                                <Typography id='custom_menu'>
                                                  <BasicInput
                                                    value={getValue(clroContent.Concentrations[element][ele][eleData], 2)}
                                                    disabled={disableInput}
                                                    id={`input_num${elementInd}_${ind + 1}`}
                                                    onFocus={(e) => { changeFocus(e); }}
                                                    onContextMenu={handleRightClick}
                                                  />
                                                </Typography>
                                              </td>
                                            </React.Fragment>
                                          );
                                        });
                                      })}
                                    </tr>
                                  );
                                });
                              }
                              return '';
                            })}
                          </tbody>
                        </table>
                        {/* By ABhishek  */}
                        <Menu id='custom_menu'
                          open={contextMenu !== null}
                          onClose={handleClose}
                          anchorReference='anchorPosition'
                          anchorPosition={
                            contextMenu !== null
                              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                              : undefined
                          }
                        >
                          <MenuItem onClick={() => { copyCell(targetValue); handleClose(); }}>
                            <span>Copy</span>
                          </MenuItem>
                          <MenuItem onClick={() => { copyCellHead(targetElement, properties, targetValue); handleClose(); }}>
                            <span>Copy Cell with Headers</span>
                          </MenuItem>
                          <MenuItem onClick={() => { copyRowHead(targetElement, properties, griddata); handleClose(); }}>
                            <span>Copy Row with Headers</span>
                          </MenuItem>
                          <MenuItem onClick={() => { copyColHead(targetElement, properties, griddata); handleClose(); }}>
                            <span>Copy Column with Headers</span>
                          </MenuItem>
                          <MenuItem onClick={() => { copyTable(properties, griddata); handleClose(); }}>
                            <span>Copy Table </span>
                          </MenuItem>
                          <MenuItem onClick={() => { exportFromJSON({ data: griddata, fileName, exportType: 'csv' }); handleClose(); }}>
                            <span>Export as CSV</span>
                          </MenuItem>
                          <MenuItem onClick={() => {
                            const worksheet = XLSX.utils.json_to_sheet(griddata);
                            const workbook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                            XLSX.writeFile(workbook, `${fileName}.xlsx`);
                            handleClose();
                          }}>
                            <span>Export as Excel</span>
                          </MenuItem>
                        </Menu>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </Grid>
          </TabPanel>
        </TabContext>) : <span className=''>No Data found...</span>}
      </Grid>
    </div>
  );
};

export default CLROPage;